//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import subModelCreate from '../components/subModelCreate.vue';
import _ from 'lodash';
export default {
  components: {
    subModelCreate,
  },
  data() {
    return {
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      statusMap: {
        0: {
          img: 'https://cdn.nges.tencent.com/nges_1/31105202/098506cd-549e-4ccd-9f44-e6118b67e853.png',
          title: '待执行',
        },
        2: {
          img: 'https://cdn.nges.tencent.com/nges_1/31105202/0d159fe2-2179-4bef-baaa-59bb5db42cff.png',
          title: '执行中',
        },
        3: {
          img: 'https://cdn.nges.tencent.com/nges_1/31105202/8768958e-fc9f-4468-a1ba-516f1a0013cf.png',
          title: '已完成',
        },
        4: {
          img: 'https://cdn.nges.tencent.com/nges_1/31105202/11b40f35-ffea-41d8-bf74-9e0d01ac7ffb.png',
          title: '失败',
        },
        5: {
          img: 'https://cdn.nges.tencent.com/nges_1/31105202/11b40f35-ffea-41d8-bf74-9e0d01ac7ffb.png',
          title: '部分失败',
        },
      },
      tableData: [],
      // 加载状态
      loading: false,
      // 搜索表单
      sandBoxSearch: {
        sandbox_name: '',
        sandbox_type: '',
        task_status: '',
        create_time: '',
        update_time: '',
        update_by: '',
      },
      // 新建窗口展示
      createVisible: false,
      // 模型文件部署
      deployVisible: false,
      detailVisible: false,
      cloneVisible: false,
      operateType: '',
      rowMessage: {},
    };
  },
  computed: {
    providerName() {
      return this.$route.query.provider_name;
    },
    ...mapGetters('user', ['getElementList']),
    jurisdiction() {
      const jurisdictionArray = [
        'aiAgentAiSubModelList_agent_addModel',
        'aiAgentAiSubModelList_agent_edit',
        'aiAgentAiSubModelList_agent_delete',
      ];
      const jurisdictionObj = {};
      for (const item of jurisdictionArray) {
        jurisdictionObj[item] = this.getElementList.includes(item);
      }
      return jurisdictionObj;
    },
  },
  watch: {},
  created() {
    this.getList();
  },
  methods: {
    toAdd() {
      this.operateType = 'add';
      this.createVisible = true;
    },
    edit(row) {
      this.rowMessage = row;
      this.operateType = 'edit';
      this.createVisible = true;
    },

    toDelete(row) {
      console.log('%c Line:268 🥚 row', 'color:#f5ce50', row);
      const params = {
        provider_name: row.provider_name,
        model_name: row.model_name,
      };
      this.$request({
        url: this.$api.aiDeleteModel,
        data: params,
      }).then((res) => {
        console.log('%c Line:130 🍫 res', 'color:#33a5ff', res);
        this.refresh();
      });
    },
    refresh() {
      this.resetPage();
      this.getList();
    },

    // 获取列表数据
    getList() {
      this.loading = true;
      console.log('%c Line:263 🍺 this.sandBoxSearch)', 'color:#465975', this.sandBoxSearch);
      return this.$request({
        url: this.$api.getAiListModel,
        data: {
          provider_name: this.providerName,
        },
      })
        .then((res) => {
          // res
          console.log('%c Line:261 🍊 res', 'color:#7f2b82', res);
          const computedList = res.models.map((item) => ({
            ...item,
            enabled: item.enabled ? '是' : '否',
          }));
          this.tableData = computedList;
          this.loading = false;
        })
        .catch((err) => {
          // err
          console.log('%c Line:261 🍺 err', 'color:#42b983', err);
          this.loading = false;
        });
    },
    // 表单查询
    handleChange: _.debounce(function () {
      this.refresh();
    }, 1000),

    handleReset() {
      this.resetPage();
      this.refresh();
    },

    resetPage() {
      this.pageIndex = 1;
      this.pageSize = 10;
    },
    // 分页器
    handleSizeChange(value) {
      this.pageIndex = 1;
      this.pageSize = value;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getList();
    },
    goBack() {
      this.$router.history.go(-1);
    },
  },
};
